import { Link } from "react-router-dom";
import { COURSES, LEVEL_META, LEVEL_FAQS } from "./trainingData";

const ALL_LEVEL_SLUGS = [
  { slug: "networking-essentials", title: "Level 1: Networking Essentials" },
  { slug: "operating-systems-and-linux-fundamentals", title: "Level 2: Operating Systems & Linux Fundamentals" },
  { slug: "cybersecurity-essentials", title: "Level 3: Cybersecurity Essentials" },
  { slug: "ethical-hacking-and-countermeasures", title: "Level 4: Ethical Hacking & Countermeasures" },
  { slug: "penetration-testing-and-vulnerability-management", title: "Level 5: Penetration Testing & Vulnerability Management" },
  { slug: "soc-analyst-and-threat-detection", title: "Level 6: SOC Analyst & Threat Detection" },
  { slug: "cybersecurity-grc", title: "Level 7: Cybersecurity GRC" },
  { slug: "security-automation-and-python", title: "Level 8: Security Automation & Python for Security" },
  { slug: "ai-security", title: "Level 9: AI Security" },
  { slug: "cloud-security", title: "Level 10: Cloud Security" },
];

export default function LevelLayout({ lvl }) {
  const course = COURSES.find((c) => c.lvl === lvl);
  const meta = LEVEL_META.find((m) => m.lvl === lvl);
  const faqs = LEVEL_FAQS[lvl] || [];
  const regularModules = course.modules.filter((m) => !m.startsWith("AI"));
  const aiModules = course.modules.filter((m) => m.startsWith("AI"));

  const aiCount = aiModules.length;

  return (
    <div className="bg-black text-white min-h-screen">
      <main className="max-w-[1100px] mx-auto px-6">
        <nav aria-label="Breadcrumb" className="font-mono text-[11px] text-[#52525b] pt-7" style={{ letterSpacing: "0.12em" }}>
          <Link to="/" className="text-[#52525b] hover:text-white">HOME</Link> /{" "}
          <span className="text-[#a1a1aa]">LEVEL {lvl}</span>
        </nav>

        <header className="pt-11 pb-10 border-b border-[#18181b]">
          <div className="font-mono text-[12px] text-[#a3e635] mb-5" style={{ letterSpacing: "0.18em" }}>
            LEVEL {lvl} · {course.stage} · {course.difficulty}
          </div>
          <h1
            className="font-bold text-white mb-[22px] max-w-[900px]"
            style={{ fontSize: "clamp(34px, 5vw, 60px)", lineHeight: 1.02, letterSpacing: "-0.03em" }}
          >
            {course.title}
          </h1>
          <p className="text-[16px] sm:text-[19px] leading-[1.6] text-[#a1a1aa] max-w-[720px] mb-[28px]">
            {course.desc}
          </p>
          <div className="flex flex-wrap gap-[9px] mb-[30px]">
            <span className="border border-[#a3e635] text-[#a3e635] rounded-full px-3.5 py-[7px] font-mono text-[11px] whitespace-nowrap" style={{ letterSpacing: "0.08em" }}>
              {aiCount} AI TOPICS INCLUDED
            </span>
            <span className="border border-[#3f3f46] text-[#d4d4d8] rounded-full px-3.5 py-[7px] font-mono text-[11px] whitespace-nowrap" style={{ letterSpacing: "0.08em" }}>
              RECORDED VIDEO + LABS
            </span>
            <span className="border border-[#3f3f46] text-[#d4d4d8] rounded-full px-3.5 py-[7px] font-mono text-[11px]" style={{ letterSpacing: "0.08em" }}>
              ONLINE EXAM + CERTIFICATE
            </span>
            <span className="border border-[#3f3f46] text-[#d4d4d8] rounded-full px-3.5 py-[7px] font-mono text-[11px] whitespace-nowrap" style={{ letterSpacing: "0.08em" }}>
              SYLLABUS UPDATED FOR 2026
            </span>
          </div>
          <div className="flex items-center gap-[22px] flex-wrap">
            <div className="flex items-baseline gap-2.5">
              <span className="font-mono text-[18px] text-[#52525b] line-through">{course.was}</span>
              <span className="text-[32px] sm:text-[42px] font-bold leading-none" style={{ letterSpacing: "-0.03em" }}>{course.price}</span>
            </div>
            <Link to="/#enroll" className="bg-white text-black px-5 sm:px-[30px] py-[15px] rounded-lg font-semibold text-[16px] whitespace-nowrap hover:bg-[#e4e4e7] transition-colors">
              Enroll in Level {lvl}
            </Link>
            <Link to="/#enroll" className="border border-[#3f3f46] text-white px-5 sm:px-[30px] py-[15px] rounded-lg font-semibold text-[16px] whitespace-nowrap hover:border-white transition-colors">
              All 10 levels for $499
            </Link>
          </div>
        </header>

        <section className="py-9">
          <div className="grid grid-cols-[repeat(auto-fit,minmax(170px,1fr))] gap-px bg-[#27272a] border border-[#27272a] rounded-xl overflow-hidden">
            {[
              { label: "DURATION", value: meta.duration },
              { label: "MODULES", value: course.mods },
              { label: "HANDS-ON LABS", value: course.labs },
              { label: "LEVEL", value: course.difficulty },
              { label: "CERTIFICATION", value: "Included" },
            ].map((item) => (
              <div key={item.label} className="bg-black p-5">
                <div className="font-mono text-[10px] text-[#71717a]" style={{ letterSpacing: "0.1em" }}>{item.label}</div>
                <div className="text-[20px] font-bold mt-1.5">{item.value}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="py-11 border-t border-[#18181b]">
          <h2 className="font-bold text-white mb-[18px]" style={{ fontSize: "clamp(26px, 3.2vw, 38px)", lineHeight: 1.1, letterSpacing: "-0.025em" }}>
            What you will learn in Level {lvl}
          </h2>
          <p className="text-[17px] leading-[1.65] text-[#a1a1aa] max-w-[720px] mb-[30px]">
            {course.mods} recorded modules and {course.labs} hands-on labs, all graded in our browser-based cyber range. Prepares you for: {meta.roles}
          </p>
          <ul className="columns-1 sm:columns-2 gap-[44px] max-w-[900px]">
            {regularModules.map((m, i) => (
              <li key={i} className="flex gap-3 text-[15px] text-[#d4d4d8] leading-[1.6] mb-3">
                <span className="text-[#a3e635] font-mono text-[13px]">/</span>
                <span>{m.replace(/^AI \u00B7 /, "")}</span>
              </li>
            ))}
          </ul>
        </section>

        {aiModules.length > 0 && (
          <section className="py-11 border-t border-[#18181b]">
            <h2 className="font-bold text-white mb-[18px]" style={{ fontSize: "clamp(26px, 3.2vw, 38px)", lineHeight: 1.1, letterSpacing: "-0.025em" }}>
              AI security topics inside this level
            </h2>
            <p className="text-[17px] leading-[1.65] text-[#a1a1aa] max-w-[720px] mb-[30px]">
              Most syllabuses have not caught up with AI. Every Hack Defense level &mdash; including this one &mdash; carries a dedicated block of AI security material, refreshed for 2026.
            </p>
            <ul className="columns-1 sm:columns-2 gap-[44px] max-w-[900px]">
              {aiModules.map((m, i) => (
                <li key={i} className="flex gap-3 text-[15px] text-[#d4d4d8] leading-[1.6] mb-3">
                  <span className="text-[#facc15] font-mono text-[13px]">/</span>
                  <span>{m.replace(/^AI \u00B7 /, "")}</span>
                </li>
              ))}
            </ul>
          </section>
        )}

        <section className="py-11 border-t border-[#18181b]">
          <h2 className="font-bold text-white mb-[22px]" style={{ fontSize: "clamp(26px, 3.2vw, 38px)", lineHeight: 1.1, letterSpacing: "-0.025em" }}>
            Tools you will use
          </h2>
          <div className="flex flex-wrap gap-[9px]">
            {course.tools.map((t, i) => (
              <span key={i} className="border border-[#27272a] rounded-md px-3.5 py-2 font-mono text-[12px] text-[#a1a1aa]">
                {t}
              </span>
            ))}
          </div>
        </section>

        <section className="py-11 border-t border-[#18181b] grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-5">
          <div className="border border-[#27272a] rounded-xl bg-[#09090b] p-7">
            <div className="font-mono text-[11px] text-[#71717a] mb-3" style={{ letterSpacing: "0.14em" }}>CAPSTONE PROJECT</div>
            <p className="text-[16px] leading-[1.65] text-[#d4d4d8] m-0">{course.capstone}</p>
          </div>
          <div className="border border-[#27272a] rounded-xl bg-[#09090b] p-7">
            <div className="font-mono text-[11px] text-[#71717a] mb-3" style={{ letterSpacing: "0.14em" }}>YOU FINISH ABLE TO</div>
            <p className="text-[16px] leading-[1.65] text-[#d4d4d8] m-0">{course.outcome}</p>
          </div>
          <div className="border border-[#27272a] rounded-xl bg-[#09090b] p-7">
            <div className="font-mono text-[11px] text-[#71717a] mb-3" style={{ letterSpacing: "0.14em" }}>CERTIFICATION MAPPED</div>
            <p className="text-[16px] leading-[1.65] text-[#d4d4d8] m-0">{course.cert}</p>
          </div>
        </section>

        <section className="py-11 border-t border-[#18181b]">
          <h2 className="font-bold text-white mb-[18px]" style={{ fontSize: "clamp(26px, 3.2vw, 38px)", lineHeight: 1.1, letterSpacing: "-0.025em" }}>
            Who Level {lvl} is for
          </h2>
          <p className="text-[17px] leading-[1.7] text-[#a1a1aa] max-w-[760px] mb-[26px]">
            {lvl === 1 && "Complete beginners with no IT background, students, and anyone who has been told to \u201Clearn networking first\u2019 and did not know where to start."}
            {lvl === 2 && "Students who have completed Level 1, IT newcomers who want to build their own lab, and anyone who needs Linux and Windows fundamentals for security."}
            {lvl === 3 && "Graduates and career changers who have the basics and want their first security certification and entry-level security conversation skills."}
            {lvl === 4 && "Security enthusiasts who want to learn offensive techniques, IT professionals moving into security, and anyone who wants to think like an attacker."}
            {lvl === 5 && "Aspiring penetration testers who have completed Level 4 and want to run professional engagements with real reporting and scoping."}
            {lvl === 6 && "Defenders who want to work in a SOC: triage alerts, investigate incidents and write the incident report. The most common first security job."}
            {lvl === 7 && "Anyone who needs to understand governance, risk and compliance \u2014 from analysts to future CISOs. GRC is where security meets the board."}
            {lvl === 8 && "Analysts and engineers who want to stop repeating work and start shipping tools. The skill that turns an analyst into an engineer."}
            {lvl === 9 && "Security professionals who want to test AI systems and write the guardrails. The fastest-growing specialisation in cybersecurity."}
            {lvl === 10 && "Security engineers who want to secure multi-cloud estates including AI workloads. The final level of the Expert Track."}
          </p>
          <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-5">
            <div className="border border-[#27272a] rounded-xl p-6 bg-black">
              <div className="font-mono text-[11px] text-[#a3e635] mb-2.5" style={{ letterSpacing: "0.12em" }}>BEFORE THIS LEVEL</div>
              <div className="text-[17px] font-semibold">{meta.prereq}</div>
              <div className="text-[14px] text-[#71717a] leading-relaxed mt-2.5">{meta.prereqNote}</div>
            </div>
            <div className="border border-[#27272a] rounded-xl p-6 bg-black">
              <div className="font-mono text-[11px] text-[#a3e635] mb-2.5" style={{ letterSpacing: "0.12em" }}>AFTER THIS LEVEL</div>
              {meta.nextSlug ? (
                <Link to={`/training/${meta.nextSlug}`} className="text-[17px] font-semibold hover:text-[#a3e635] transition-colors">
                  {meta.nextTitle} →
                </Link>
              ) : (
                <div className="text-[17px] font-semibold">You have completed the Expert Track!</div>
              )}
              {meta.nextNote && <div className="text-[14px] text-[#71717a] leading-relaxed mt-2.5">{meta.nextNote}</div>}
            </div>
          </div>
        </section>

        {faqs.length > 0 && (
          <section className="py-11 border-t border-[#18181b]">
            <h2 className="font-bold text-white mb-[26px]" style={{ fontSize: "clamp(26px, 3.2vw, 38px)", lineHeight: 1.1, letterSpacing: "-0.025em" }}>
              Level {lvl} FAQ
            </h2>
            <div className="border-t border-[#27272a] max-w-[860px]">
              {faqs.map((faq, i) => (
                <details key={i} className="border-b border-[#27272a] py-5">
                  <summary className="text-[18px] font-semibold tracking-[-0.01em] cursor-pointer list-none">
                    {faq.q}
                  </summary>
                  <p className="text-[16px] leading-[1.7] text-[#a1a1aa] mt-3.5 max-w-[720px]">
                    {faq.a}
                  </p>
                </details>
              ))}
            </div>
          </section>
        )}

        <section className="py-11 pb-16 border-t border-[#18181b]">
          <div className="border border-[#a3e635] rounded-[14px] bg-[#09090b] p-5 sm:p-9 grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-7 items-center">
            <div>
              <h2 className="font-bold text-white mb-3" style={{ fontSize: "clamp(24px, 2.8vw, 32px)", lineHeight: 1.1, letterSpacing: "-0.025em" }}>
                Start Level {lvl} today
              </h2>
              <p className="text-[16px] leading-[1.65] text-[#a1a1aa] m-0">
                Recorded video, {course.labs} labs, an online exam and a verifiable certificate. {course.price} on its own, or take all ten levels for $499 and get the CV Building &amp; Mock Interview module free.
              </p>
            </div>
            <div className="grid gap-2.5">
              <Link to="/#enroll" className="bg-white text-black px-5 sm:px-[30px] py-4 rounded-lg font-bold text-[16px] text-center hover:bg-[#e4e4e7] transition-colors">
                Enroll in Level {lvl} — {course.price}
              </Link>
              <Link to="/" className="border border-[#3f3f46] text-white px-5 sm:px-[30px] py-4 rounded-lg font-semibold text-[16px] text-center hover:border-white transition-colors">
                See the full 10-level roadmap
              </Link>
            </div>
          </div>
        </section>
      </main>

      <section className="border-t border-[#18181b]">
        <div className="max-w-[1100px] mx-auto px-6 pt-11 pb-7">
          <div className="font-mono text-[11px] text-[#52525b] mb-4" style={{ letterSpacing: "0.14em" }}>THE TEN LEVELS</div>
          <div className="grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-2.5">
            {ALL_LEVEL_SLUGS.map((l) => (
              <span key={l.slug}>
                {l.slug === meta.slug ? (
                  <span className="text-[14px] text-[#a3e635]">{l.title}</span>
                ) : (
                   <Link to={`/training/${l.slug}`} className="text-[14px] text-[#a1a1aa] hover:text-white transition-colors">{l.title}</Link>
                )}
              </span>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
